import { render, staticRenderFns } from "./Templates.vue?vue&type=template&id=82a7dc90"
import script from "./Templates.vue?vue&type=script&lang=js"
export * from "./Templates.vue?vue&type=script&lang=js"
import style0 from "./Templates.vue?vue&type=style&index=0&id=82a7dc90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports